export default __webpack_public_path__ + "static/media/gallery05.787190eb.jpg";